export const CONFIG = {
  //APIDomain: "http://localhost:5001/chatgpt-folio-demo/us-central1/", // with /
  APIDomain: "https://us-central1-chatgpt-folio-demo.cloudfunctions.net/",
  recaptchaKey: "6LenZWglAAAAABN78CudwTcuvGaEwDxBukmPOwL5",
};
